import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const ReligiousServicesIcon = ({
  width = 25,
  height = 25,
  color = '#96A2C2'
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    style={{
      fill: color,
      width: width,
      height: height
    }}
    className="icon icons8-book-filled"
  >
    <g id="surface1">
      <path d="M 12 39 L 44 39 L 44 2 L 12 2 C 8.691406 2 6 4.691406 6 8 L 6 42.417969 C 6 45.496094 8.691406 48 12 48 L 44 48 L 44 46 L 12 46 C 9.832031 46 8 44.359375 8 42.417969 C 8 40.5 9.757813 39 12 39 Z M 14 10.5 C 14 10.222656 14.222656 10 14.5 10 L 36.5 10 C 36.777344 10 37 10.222656 37 10.5 L 37 15.5 C 37 15.777344 36.777344 16 36.5 16 L 14.5 16 C 14.222656 16 14 15.777344 14 15.5 Z " />
    </g>
  </IconSvg>
)

export default ReligiousServicesIcon
